import { MyBundleStatus } from 'multirpc-sdk';

import {
  BundleChargingModel,
  BundleChargingModelBalance,
  BundleChargingModelType,
  BundleChargingModelUsage,
} from '../types';
import { CREDITS_TO_REQUESTS_RATE, CREDITS_TO_USD_RATE } from '../constants';

interface GetBundleChargingModelParams {
  bundleStatus: MyBundleStatus;
  creditsLimit: number;
  type: BundleChargingModelType;
}

export const getBundleChargingModel = ({
  bundleStatus,
  creditsLimit,
  type,
}: GetBundleChargingModelParams) => {
  const creditsBalance = bundleStatus.counters.reduce(
    (result, counter) => result + Number(counter.count) || 0,
    0,
  );

  const balance: BundleChargingModelBalance = {
    credits: creditsBalance,
    requests: creditsBalance / CREDITS_TO_REQUESTS_RATE,
    usd: creditsBalance / CREDITS_TO_USD_RATE,
  };

  const used = creditsLimit ? creditsLimit - Number(creditsBalance) : 0;
  const usagePercent = creditsLimit ? (used * 100) / creditsLimit : 0;
  const leftPercent = 100 - usagePercent;

  const usage: BundleChargingModelUsage = {
    leftPercent,
    limit: creditsLimit,
    percent: usagePercent,
    used,
  };

  const chargingModel: BundleChargingModel = {
    balance,
    expires: bundleStatus.expires,
    type,
    usage,
  };

  return chargingModel;
};
